import { Divider, Stack } from "@mui/material"
import CheckRole from "components/CheckRole"
import CustomCard from "components/CustomCard"
import SelectInput from "components/files/SelectInput"
import TextInput from "components/files/TextInput"
import { MANAGER } from "config/roles"
import { PMT_TYPE, PMT_TYPE_ID } from "containers/servicesCall/const"
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation"
import { onlyNumber } from "utils/validations"

const Payments = ({ control, data, errors, pmtTypeId }) => {
  const { bt } = useBizTypeTranslation();

  return (
    <CheckRole role={MANAGER}>
      <CustomCard spacing={2}>
        <Stack width="100%" direction='row' spacing={1}>
          <TextInput
            fullWidth
            addFlex
            errors={errors}
            validation={onlyNumber}
            name="quotationNum"
            title="QUOTATION_NUM"
            control={control}
          />

          <TextInput
            fullWidth
            addFlex
            errors={errors}
            validation={onlyNumber}
            name="orderNum"
            title="ORDER_NUM"
            control={control}
          />
          <TextInput
            fullWidth
            addFlex
            errors={errors}
            validation={onlyNumber}
            name="taxInvoiceNum"
            title="חשבון עיסקה"
            control={control}
          />
          <TextInput
            fullWidth
            addFlex
            errors={errors}
            validation={onlyNumber}
            name="invoiceNum"
            title="INVOICE_NUM"
            control={control}
          />
        </Stack>


        <Stack width="100%" direction='row' spacing={2}>
          <SelectInput
            width='auto'
            addFlex
            control={control}
            errors={errors}
            name="pmtTypeId"
            title="PMT_TYPE_ID"
            options={PMT_TYPE}
            defaultValue={data?.pmtTypeId ?? PMT_TYPE_ID.PAY}
          />

          {pmtTypeId === PMT_TYPE_ID.PAY ? (
            <TextInput
              width="100%"
              errors={errors}
              addFlex
              validation={onlyNumber}
              name="price"
              title="PRICE"
              control={control}
            />
          ) : null}
        </Stack>
      </CustomCard>
    </CheckRole>
  )
}
export default Payments